import { Component, input } from '@angular/core';
import { ButtonComponent } from '@components/button/button.component';
import { SimulationSummaryEntry } from '@services/simulation-flow.service';

interface SummaryStepMock {
  answers: readonly SimulationSummaryEntry[];
  id: string;
  status: 'completed' | 'current';
  title: string;
}

@Component({
  imports: [ButtonComponent],
  selector: 'app-simulation-summary',
  styleUrl: './simulation-summary.component.scss',
  templateUrl: './simulation-summary.component.html',
})
export class SimulationSummaryComponent {
  readonly variant = input<'card' | 'panel'>('card');

  // TODO: replace with steps derived from SimulationFlowService
  protected readonly steps: readonly SummaryStepMock[] = [
    {
      answers: [
        {
          displayValue: 'Asalariado',
          questionId: 'incomeType',
          questionLabel: '¿Cómo son los ingresos de tu cliente?',
        },
        {
          displayValue: 'Adquisición de inmueble',
          questionId: 'intent',
          questionLabel: '¿Que quiere hacer?',
        },
        {
          displayValue: 'Hipoteca Verde',
          questionId: 'offer',
          questionLabel: 'Oferta',
        },
      ],
      id: 'perfil-del-cliente',
      status: 'completed',
      title: 'Perfil del cliente',
    },
    {
      answers: [
        {
          displayValue: 'Esquema COFINAVIT',
          questionId: 'paymentProgram',
          questionLabel: '¿Usará programa de pago?',
        },
        {
          displayValue: '$80,000,000 MXN',
          questionId: 'infonavitCreditAmount',
          questionLabel: 'Monto crédito INFONAVIT',
        },
        {
          displayValue: '$8,000,000 MXN',
          questionId: 'housingSubaccountBalance',
          questionLabel: 'Saldo subcuenta de vivienda',
        },
        {
          displayValue: 'Individual',
          questionId: 'cofinancingType',
          questionLabel: 'Tipo de cofinanciamiento',
        },
      ],
      id: 'programa-de-financiamiento',
      status: 'current',
      title: 'Programa de financiamiento',
    },
  ];
}
